module.exports = __webpack_public_path__ + "img/86.b2b52a92.png";